import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Icon, InputRadio, Typography } from 'shared/ui'
import { useChatbotContext } from 'pages/chatbot/context'

import { PointAIQualify } from 'pages/chatbot/ui/ChatbotEdit/StepQualify/ui/PointAIQualify'
import { PointQualifyInstructions } from 'pages/chatbot/ui/ChatbotEdit/StepQualify/ui/PointQualifyInstructions/PointQualifyInstructions'
import { ActionSection } from 'pages/chatbot/ui/ChatbotEdit/StepQualify/ui/ActionSection/ActionSection'
import { ChatbotActions } from 'pages/chatbot/ui/ChatbotEdit/ChatbotActions'
import styles from './styles.module.scss'

type IStepQualifyContentProps = {
  type: 'default' | 'booking'
  error?: string
}

export const StepQualifyContent = observer(({ type }: IStepQualifyContentProps) => {
  const {
    model: { settings },
    qualifiedActions,
    disqualifiedActions,
    stepQualifyStore,
  } = useChatbotContext()

  const { qualifyEnabled, disqualifyBehavior, setDisqualifyBehavior } = settings

  return (
    <div
      className={classNames(styles.content, {
        [styles.booking]: type === 'booking',
      })}
    >
      <PointAIQualify />
      {qualifyEnabled && (
        <>
          <PointQualifyInstructions />
          <ActionSection
            type={'qualified'}
            icon={'check2'}
            label={'Qualified contacts'}
            desc={
              'Agent will run any optional actions first, then continue the flow to success or fallback actions.'
            }
            content={<ChatbotActions actions={qualifiedActions} />}
          />
          <ActionSection
            type={'disqualified'}
            icon={'failed'}
            label={'Disqualified contacts'}
            desc={
              'Agent will run any optional actions first, then continue with the selected option below.'
            }
            content={
              <>
                <ChatbotActions actions={disqualifiedActions} />
                <div className={styles.wrapArrow}>
                  <Icon icon={'union'} fontSize={20} color={'var(--black-30)'} />
                </div>
                <Typography
                  variant={'body-md-regular'}
                  ariaLabel={'DisqualifiedContactsOptions'}
                  color={'var(--content-primary-tertiary)'}
                >
                  Select the path for disqualified contacts:
                </Typography>
                <div className={styles.options}>
                  {stepQualifyStore.pathList.map((path) => (
                    <InputRadio
                      key={path.id}
                      label={path.customLabel}
                      checked={disqualifyBehavior === path.id}
                      onChecked={() => setDisqualifyBehavior(path.id)}
                      className={classNames(styles.radioButton, {
                        [styles.checked]: disqualifyBehavior === path.id,
                      })}
                      radioSize='small'
                    />
                  ))}
                </div>
              </>
            }
          />
        </>
      )}
    </div>
  )
})
